import React, {useState} from "react";
import './HeaderSmallDivs.css';
import bamb_menu from "../../../../static/img/Header/gamburger.svg";
import terminal_header from '../../../../static/img/Header/Terminal.svg';
import chat_header from '../../../../static/img/Header/Comment.svg';
import ChangeLink from "../../../ChangeLink/ChangeLink";
import MainMenuArray from "../MainMenu/MainMenuArray";





function HeaderSmallDivsOne(props){
    const [SmallMenuVisible, setSmallMenuVisible] = useState('isNoVisible');
    const [Active, setActive] = useState(props.Active);

    function MakeInVisibleMenu(){setSmallMenuVisible('isNoVisible')}

    function MakeVisibleMenu(){setSmallMenuVisible('isVisible');}

    const SubmenuWork = (Submenu,lang) => { // Правила по которым создается новый массив при окончании перемещения элементов мышкой
        const result = Array.from(Submenu);
        return result.map(function(SubMenuElement,index) {
            return (
                <div key={index} className="phoneMenuMainElementSubMenuElement">
                    <ChangeLink lang={lang} to={SubMenuElement.href} activeClassName="phoneMenuMainElementSubMenuElement phoneMenuMainElementSubMenuElementActive" style={{textDecoration: 'none'}}>{SubMenuElement.Name[lang]}</ChangeLink>
                </div>

            )
        });};

    const topMenu = (A,self,lang) => MainMenuArray.map(function(MenuElement,index) {
        let ActiveElement = '';
        if (index===A)   {ActiveElement = 'phoneMenuMainElementActive'}
        return (
            <div key={index} className={"phoneMenuMainElement " + ActiveElement}>
                <div className="phoneMenuMainElementTitle" role = "button" tabIndex={0} onClick={() => MakeVisibleThisMenu(index)}>{MenuElement.Name[lang]}</div>
                <div className="phoneMenuMainElementSubMenu">
                    {SubmenuWork(MenuElement.Submenu,lang)}
                </div>
            </div>
        )});

    function MakeVisibleThisMenu(idActive) {setActive(idActive);}
        //console.log('HeaderSmallDivsOne',props);
            return (
      <div className="menu_header_small"><input type="image" src={bamb_menu} width="27px" onClick={() => MakeVisibleMenu()} alt='alt'/>
          <div role = "button" tabIndex={0} className={"for_cab " + SmallMenuVisible}  onClick={MakeInVisibleMenu.bind(this)}> </div>

          <div className={"phoneMenu " + SmallMenuVisible}>
              <div className="phoneMenuTopButtons">
                  <ChangeLink to={"/"} style={{textDecoration: 'none'}}><div className="phoneMenuTopButtonsElement">
                      <img src={terminal_header}  width="15" height="15" alt='alt'/>
                      Web-Terminal
                  </div></ChangeLink>
                  <ChangeLink to={"/"} style={{textDecoration: 'none'}}><div className="phoneMenuTopButtonsElement">
                      <img src={chat_header} width="15" height="15" alt='alt'/>
                      Live Chat
                  </div></ChangeLink>
              </div>
              <div className="phoneMenuMain">
                  {topMenu(Active,this,props.lang)}
              </div>
          </div>
      </div>
)}

export default HeaderSmallDivsOne


